import SearchInput from '@acko-tech/building-blocks.ui.search-input';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSegmentViewEvents } from 'hooks/useSegmentView';
import { useViewport } from 'utils/responsive';
import Image from 'next/image';
import { useContext, useEffect, useState } from 'react';
import { MPosContext } from 'utils/context';
import { getImageBasePath, getPlanName } from 'utils/generics';
import {
    SegmentEventNameTypes,
    SegmentEventPageTypes,
    SegmentEventPages,
    PRODUCT,
    SUB_PRODUCT_NAME,
} from 'utils/segment/constants';
import Header from 'widgets/header';
import TransactionDetailsCard from './detailsCard';
import TransactionItemCard from './itemCard';
import { PageLoader } from 'utils/styles';
import { getDD_Month_Time } from 'utils/date';
import * as Styles from './styles';

function Transactions() {
    const { setShowHamburger, partnerId } = useContext(MPosContext);

    const [searchValue, setSearchValue] = useState('');
    const [transactions, setTransactions] = useState([]);
    const [searchResultTransactions, setSearchResultTransactions] = useState(
        []
    );
    const [selectedTransaction, setSelectedTransaction] = useState<any>({});
    const [page, setPage] = useState(0);
    const [searchResultPage, setSearchResultPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [showTransaction, setShowTransaction] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { isMobile } = useViewport();
    /**
     * view segment hook
     */

    useSegmentViewEvents(SegmentEventNameTypes.VIEW, {
        page_url: typeof window !== 'undefined' ? window.location.href : '',
        page_type: SegmentEventPageTypes.MAIN_PAGE,
        view_name: SegmentEventPages.VIEW_MY_TRANSACTIONS,
        product: PRODUCT,
        sub_product_name: SUB_PRODUCT_NAME,
        platform: isMobile ? 'mweb' : 'web',
        referrer: document.referrer || '',
        device: navigator.userAgent || '',
        partner: partnerId,
    });

    useEffect(() => {
        getTransactions();
    }, []);

    useEffect(() => {
        let timeout: any;
        if (searchValue.length > 2) {
            timeout = setTimeout(() => {
                getTransactions();
                setSearchResultPage(0);
                setIsLoading(true);
            }, 1000);
        }
        return () => clearTimeout(timeout);
    }, [searchValue]);

    function getTransactions() {
        import('./apis').then(async (req) => {
            setIsLoading(true);
            const isSearchCall = searchValue?.length > 2;
            const { status, data } = await req.getTransactions(
                partnerId,
                isSearchCall ? searchResultPage : page,
                searchValue
            );
            setIsLoading(false);
            if (status && data?.transactions) {
                if (isSearchCall) {
                    setSearchResultTransactions(data.transactions || []);
                } else {
                    setTransactions((transactions) =>
                        transactions.concat(data.transactions || [])
                    );
                }
                if (data?.transactions.length > 9) {
                    if (isSearchCall) {
                        setSearchResultPage((page) => page + 1);
                    } else {
                        setPage((page) => page + 1);
                    }
                    setHasMore(true);
                } else {
                    setHasMore(false);
                }
            }
        });
    }

    const onBack = () => {
        if (showTransaction) {
            setShowTransaction(false);
        } else {
            setShowHamburger(true);
        }
    };

    const getTransactionList = () => {
        const isSearchCall = searchValue?.length > 2;
        if (isSearchCall) return searchResultTransactions;
        return transactions;
    };

    return (
        <Styles.Wrapper>
            <Header />
            <Styles.Header>
                <Styles.BackArrowIcon>
                    <Image
                        width={'10px'}
                        height={'24px'}
                        alt={''}
                        src={getImageBasePath('/icons/backArrow.svg')}
                        onClick={onBack}
                    />
                </Styles.BackArrowIcon>
            </Styles.Header>
            {showTransaction ? (
                <TransactionDetailsCard
                    planName={getPlanName(selectedTransaction?.plan?.plan_name)}
                    premium={selectedTransaction?.plan?.premium}
                    deviceName={selectedTransaction?.device?.name}
                    serialNumber={selectedTransaction?.device?.serial_number}
                    paidBy={selectedTransaction?.payment_details?.user_name}
                    customerMobileNumber={selectedTransaction?.customer?.phone}
                    paidOn={getDD_Month_Time(
                        new Date(
                            selectedTransaction?.payment_details?.timestamp
                        )
                    )}
                    deviceType={selectedTransaction.device.category}
                />
            ) : (
                <>
                    <Styles.TransactionText>
                        My transactions
                    </Styles.TransactionText>
                    <Styles.TransactionSearchFlex>
                        <div>
                            <SearchInput
                                className={''}
                                placeholder={
                                    'Search by name, mobile number, serial-number'
                                }
                                handleChange={(vaue) => setSearchValue(vaue)}
                            />
                        </div>
                    </Styles.TransactionSearchFlex>
                    {isLoading ? (
                        <PageLoader
                            style={{ width: '60px' }}
                            src={getImageBasePath('/gif/pageLoader.gif')}
                        />
                    ) : getTransactionList().length === 0 ? (
                        <Styles.NoResult>No transactions</Styles.NoResult>
                    ) : (
                        <InfiniteScroll
                            dataLength={getTransactionList().length}
                            next={getTransactions}
                            hasMore={hasMore}
                            loader={<></>}
                        >
                            {getTransactionList().map((transaction: any) => (
                                <>
                                    <Styles.TransactionCard>
                                        <div
                                            style={{ width: '100%' }}
                                            onClick={() => {
                                                setSelectedTransaction(
                                                    transaction
                                                ),
                                                    setShowTransaction(true);
                                            }}
                                        >
                                            <TransactionItemCard
                                                value1={
                                                    transaction?.customer
                                                        ?.name ||
                                                    transaction?.customer?.phone
                                                }
                                                value2={`₹${transaction?.plan?.premium}`}
                                                value3={
                                                    transaction?.device?.name
                                                }
                                                value4={
                                                    transaction?.device
                                                        ?.purchase_date
                                                }
                                            />
                                        </div>
                                    </Styles.TransactionCard>
                                    <Styles.Hr />
                                </>
                            ))}
                        </InfiniteScroll>
                    )}
                </>
            )}
        </Styles.Wrapper>
    );
}

export default Transactions;
